// extracted by mini-css-extract-plugin
export default {"container":"integration_container__v3HLk"};